import { Pressable, Image } from 'react-native'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import useDimension from '../../hooks/use-dimension'
import PageBg from '../../components/PageBg'
import { imgWelcome } from '../../data/images'
import { useGameContext } from '../../context/GameContext'
import { useState } from 'react'
import MusicModal from '../../components/modal/MusicModal'
import { useAudio } from '../../context/AudioContext'

const { bgWelcome, btnEnter } = imgWelcome

function Welcome() {
  const { ws } = useDimension()
  const { role } = useGameContext()

  const navigate = useNavigate()

  const [verify, setVerify] = useState(false)

  const { playAudio, pauseAudio } = useAudio()

  const onIntro = () => navigate('/intro', { replace: true })
  const onMain = () => navigate('/main', { replace: true })

  const onMusic = () => {
    setVerify(() => true)
  }

  const onYes = () => {
    playAudio()
    onIntro()
  }
  const onCancel = () => {
    pauseAudio()
    onIntro()
  }

  return (
    <PageBg src={bgWelcome} alt={`bg-welcome`} noMusic={true}>
      <Pressable
        style={({ pressed }) => [
          {
            opacity: pressed ? 0.5 : 1.0,
            position: 'absolute',
            top: 490.5 * ws,
          },
        ]}
        onPress={() => {
          if (role) {
            onMain()
          } else {
            onMusic()
          }
        }}
      >
        <motion.div
          className="motion-wrapper btn"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 1 }}
        >
          <Image
            source={{ uri: btnEnter }}
            style={{
              width: 270 * ws,
              height: 79.1 * ws,
            }}
            resizeMode="contain"
            aria-label={`btn-enter`}
          />
        </motion.div>
      </Pressable>
      <MusicModal isOpen={verify} onYes={onYes} onCancel={onCancel} />
    </PageBg>
  )
}

export default Welcome
